'use strict';

var Parser = require('../parser');
var SimpleContent = Parser.SimpleContent;

function ResolvedContent(value, path, bundleName, context) {
    this._value = typeof value === 'string' ?
        Parser.parse(value, bundleName + '/' + path) : value;

    this._path = bundleName;
    this._bundleName = bundleName;
    this._context = context;
}

ResolvedContent.prototype = {
    resolve: function (context) {
        if (context) {
            context = Object.assign({}, this._context, context);
        }
        return new ResolvedContent(this._value, this._path, this._bundleName, context);
    },

    get: function (data, context) {
        var value;
        if (context) {
            context = Object.assign({}, this._context, context);
        }
        if (data) {
            value = this.getText(data, context);
        } else {
            value = this._value;
            if (value instanceof SimpleContent) {
                value = value.resolve(data, context);
            }
        }

        return value;
    },

    getText: function (data, context) {

        var value = this._value;

        if (value && value.resolve) {
            return value.resolve(data, context || this._context);
        }

        return value;
    },

    toString: function () {
        return this.getText();
    }
};

module.exports = ResolvedContent;
